import { InjectionToken } from '@angular/core';

export type DestinationsDataConfig = {
  apiPrefix: string;
};

export const DESTINATIONS_DATA_CONFIG =
  new InjectionToken<DestinationsDataConfig>('destinations-data-config');
